
import {throwError as observableThrowError,  Observable ,  of } from 'rxjs';

import {map} from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from './User';
import { Router } from '@angular/router';
import { LocalStorage } from './localstorage.service';
import { reject } from 'q';
import { Http } from '@angular/http';
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { SuspendedTicket } from './qualityticketqueue.model';


@Injectable()
export class QualityTicketService {

    private url = 'api/qualityticketqueue';

    constructor(private http: HttpClient, private _http: Http) { }

    getQualityTickets(state: string): Observable<SuspendedTicket[]> {
        return this._http.get(`${this.url}?state=${state}`).pipe(map(res =>
            res.json()));
    }

    lockQualityTicket(QualityTicketId: number, LockedBy: string, state: string): Observable<any> {

        return this.http.put(`${this.url}/qualityqueue?QualityTicketId=${QualityTicketId}&LockedBy=${LockedBy}&state=${state}`,'');
    }

    getQualityTicketsByCategory(category: string, state: string): Observable<SuspendedTicket[]> {
        
        return this._http.get(`${this.url}/getbycategory?category=${category}&state=${state}`).pipe(map(res =>
            res.json()));
    }
    getDeferredTickets(username: string, state: string): Observable<SuspendedTicket[]> {

        return this._http.get(`${this.url}/getdeferred?UserName=${username}&state=${state}`).pipe(map(res =>
            res.json()));
    }

    generateQualityTicketQueueInternal(username: string, state: string): Observable<SuspendedTicket[]> {
        return this._http.get(`${this.url}/generatequeueinternal?UserName=${username}&state=${state}`).pipe(map(res =>
            res.json()));
    }

    clearQualityQueueInternal(username: string, state: string): Observable<SuspendedTicket[]> {
        return this.http.delete<SuspendedTicket[]>(`${this.url}/clearqueueinternal?UserName=${username}&state=${state}`);
    }

    generateQualityTicketQueueExternal(username: string, state: string): Observable<SuspendedTicket[]> {
        return this._http.get(`${this.url}/generatequeueexternal?UserName=${username}&state=${state}`).pipe(map(res =>
            res.json()));
    }

    clearQualityQueueExternal(username: string, state: string): Observable<SuspendedTicket[]> {
        return this.http.delete<SuspendedTicket[]>(`${this.url}/clearqueueexternal?UserName=${username}&state=${state}`);
    }

    getOldTicket(username: string, category: string, state: string): Promise<SuspendedTicket> {
        return new Promise<SuspendedTicket>(resolve => {
            this.http.get<SuspendedTicket>(`${this.url}/getoldest`, { params: { UserName: username,  Category: category, state: state} })
                .subscribe(data =>
                    resolve(data));
            setTimeout(() => resolve(), 30000);
        });
    }

    deferTicket(username: string, GcTicketNumber: string, state: string): Observable<SuspendedTicket> {
        return this.http.put<SuspendedTicket>(`${this.url}/deferticket?username=${username}&GcTicketNumber=${GcTicketNumber}&state=${state}`, '');
    }

    // Exception Handling
    private _exceptionHandler(err: HttpErrorResponse) {
        return observableThrowError(err.message);
    }
}